// 是否在飞书群 tab 中(飞书给的方案)
export const isLarkGroupTabEnv = typeof window !== 'undefined' && window?.name === 'chatTab';
